import { ChangeAlertCallbackType } from "../components/Root";
import { getPosition } from "./PositionService";
import * as API from '../http/api';

export class AfbCardService {
    private changeAlert: ChangeAlertCallbackType
    constructor(changeAlert: ChangeAlertCallbackType) {
        this.changeAlert = changeAlert
    }

    async afbCardSearch(data) {
        const pos = getPosition();
        const response = await API.service('afbCardSearch', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    
    async afbCardUpdateBilled(data) {
        const pos = getPosition();
        const response = await API.service('afbCardUpdateBilled', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async afbCardUpdateDeadline(data) {
        const pos = getPosition();
        const response = await API.service('afbCardUpdateDeadline', data, pos, this.changeAlert, null, null);

        return response?.data
    }

}